module.exports = __webpack_public_path__ + "58bb1c9ea5ab62c9671654126ea472ef.jpg";